import { useQuery } from '@tanstack/react-query';
import { reviewService } from '../../services';

export const FEED_QUERY_KEY = 'feed';

export function useFeed(enabled = true) {
  return useQuery({
    queryKey: [FEED_QUERY_KEY],
    queryFn: () => reviewService.getFeed(),
    enabled,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
}
